import React from 'react';

import LanguageIcon from '@material-ui/icons/Language';

import OpenCostIcon from '../../images/icons/opencost.svg';
import { ArgoCDLogo } from './ArgoCDLogo';
import { GrafanaLogo } from './GrafanaLogo';
import { OtelLogo } from './OtelLogo';
import { PrometheusLogo } from './PrometheusLogo';
import { SlackLogo } from './SlackLogo';

export const LinkIcon = ({ name }: { name: string }) => {
  switch (name) {
    case 'grafana':
      return <GrafanaLogo />;
    case 'otel':
      return <OtelLogo />;
    case 'argo':
      return <ArgoCDLogo />;
    case 'opencost':
      return <img height="18" src={OpenCostIcon} alt="OpenCost logo" />;
    case 'prometheus':
      return <PrometheusLogo />;
    case 'slack':
      return <SlackLogo />;
    default:
      return <LanguageIcon fontSize="small" />;
  }
};
